angular.module('zc.projects')

.directive 'campaignPriceDistribution', ($translate, CampaignStats, Chart) ->
  restrict: 'E'
  scope: {
    campaign: '='
    filters: '='
  }
  template: '<highchart config="chartConfig"></highchart>'

  link: (scope, element, attrs) ->
    updateData = ->
      CampaignStats.getHourlyConversionPriceDistribution
        apikey: scope.campaign.apikey
        campaign_id: scope.campaign.id
        start_at: scope.filters.start_at
        end_at: scope.filters.end_at
      .then (data) ->
        scope.chartConfig = Chart.getChartConfig('campaignPriceDistribution')
        chartData = ([datum.price_from, datum.count] for datum in data)
        Chart.addSeries scope.chartConfig, { name: $translate.instant('projectsCampaigns.directives.campaignPriceDistricution.campaignConversionCount'), data: chartData }
    scope.$watch 'filters', updateData, true



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/directives/campaign_price_districution.coffee